import axios from 'axios';

const KEY = 'AIzaSyCGO-vFbcCOZgZpv40Y46cxvV7cbCVYrZ0';

export default axios.create({
    baseURL: 'https://www.googleapis.com/youtube/v3', 
    params: {
        part: 'snippet',
        type: 'video',
        maxResults: 5,
        key: KEY
    }
});
